import PropTypes from 'prop-types';
import s from './BackButton.module.css';
import { ArrowLeft } from 'components/iconComponent/ArrowLeft';

const { NavLink } = require('react-router-dom');

const BackButton = ({ path }) => {
  return (
    <NavLink to={path}>
      <button className={s.button}>
        <ArrowLeft />
      </button>
    </NavLink>
  );
};

export { BackButton };

BackButton.propTypes = {
  path: PropTypes.string.isRequired,
};
